import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { PreconActions } from "@preconBlueprint/Store/PreconState";
import { DispatchProp } from "react-redux";


type HandlerType = Handler<
    {},
    DispatchProp<PreconActions> & {
        firstName?: string;
        lastName?: string;
        phone: string;
        companyName: string;
        jobTitle: string;
    }
>;

export const DispatchSetInitialValues: HandlerType = props => {
    // const account = getCurrentAccountState(props.getState()).value;
    // if (!account) {
    //     throw new Error(
    //         "There was no current account and we were trying to set initial values for the account settings page.",
    //     );
    // }

    props.dispatch({
        type: "Pages/AccountSettings/PreconSetInitialValues",
        firstName: props.firstName,
        lastName: props.lastName,
        phone: props.phone,
        companyName: props.companyName,
        jobTitle: props.jobTitle,
        // account,
    });
};

export const chain = [DispatchSetInitialValues];

const preconSetInitialValues = createHandlerChainRunnerOptionalParameter(chain, {}, "PreconSetInitialValues");
export default preconSetInitialValues;
